module.exports = __webpack_public_path__ + "img/Sniper.b7c922b9.png";